import { ITEM_ADD } from './itemReducer/actionTypes';
import { ACTION_TYPE_MONITOR } from './actions';

export const mwAddRecentInteraction = (addRecentInteraction) => () => (next) => (action) => {
    if (action.type === ITEM_ADD) {
        const item = action.item || {};
        addRecentInteraction(item.username);
    }

    next(action);
};

export const mwMonitor = (sendGraph) => () => (next) => (action) => {
    if (action.type === ACTION_TYPE_MONITOR) {
        sendGraph({ label: action.label });
    }

    next(action);
};
